import React, {useEffect, useState} from 'react';
import CommonInput from "../common/CommonInput/CommonInput";
import {Formik} from "formik";
import css from './Login.module.scss'
import {authApi} from "../../redux/auth/auth-api";
import * as Yup from 'yup'
import {Redirect} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {isCyrilic} from "../../utils";

const Register = ({isSuccessRegister, setIsSuccessRegister}) => {
  const [isPasswordsEqual, setIsPasswordsEqual] = useState(true)
  const [isEmailExist, setIsEmailExist] = useState(false)

  const {t} = useTranslation()
  const [isShowPassword ,setIsShowPassword] = useState(false)
  const [isShowRepeatPassword, setIsShowRepeatPassword] = useState(false)
  if (isSuccessRegister) {
    return <Redirect to={'/auth'}/>
  }
  return (
    <div className={css.formWrapper}>
      <Formik
        initialValues={{
          email: '',
          password: '',
          repeatPassword: ''
        }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email(t('mailDoesNotExist'))
            .required(t('requiredField')),
          password: Yup.string()
            .min(8, t('passwordChars'))
            .required(t('requiredField')),
          repeatPassword: Yup.string()
            .min(8, t('passwordChars'))
            .required(t('requiredField')),
        })}
        onSubmit={async (values, {resetForm, setFieldError}) => {
          let isAnyError = false
          if(!isCyrilic(values.email)) {
            isAnyError = true
            setFieldError('email', `${t('enter')} email ${t('onlyEnglish')}`)
          }
          if(!isAnyError) {
            setIsEmailExist(false)
            if (values.password === values.repeatPassword) {
              try {
                await authApi.register(values.email, values.password)
                resetForm()
                setIsSuccessRegister(true)
              } catch (e) {
                setIsEmailExist(true)
              }
            }
          }
        }}
      >
        {formikProps => {
          if (formikProps.values.password === formikProps.values.repeatPassword) {
            setIsPasswordsEqual(true)
          } else {
            setIsPasswordsEqual(false)
          }
          return (
            <form onSubmit={formikProps.handleSubmit}>
              <CommonInput type={'email'} caption={'Email'}
                           value={formikProps.values.email} setValue={formikProps.handleChange} id={'email'}
                           error={formikProps.submitCount > 0 && (formikProps.errors.email || (isEmailExist && t('emailExist')))}/>
              <CommonInput type={'password'} caption={t('password')}
                           isPassword={true} setIsShowPassword={() => setIsShowPassword(!isShowPassword)}
                           isShowPassword={isShowPassword}
                           value={formikProps.values.password} setValue={formikProps.handleChange} id={'password'}
                           error={formikProps.submitCount > 0 && formikProps.errors.password}/>
              <CommonInput type={'password'} caption={t('confirmPassword')}
                           value={formikProps.values.repeatPassword} setValue={formikProps.handleChange}
                           isPassword={true} setIsShowPassword={() => setIsShowRepeatPassword(!isShowRepeatPassword)}
                           isShowPassword={isShowRepeatPassword}
                           id={'repeatPassword'}
                           error={formikProps.submitCount > 0 && (formikProps.errors.repeatPassword || (!isPasswordsEqual && t('passwordMismatch')))}/>
              <button type={'submit'} className={'submit-button'}>
                {t('signUp')}
              </button>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default React.memo(Register);
